import { useContext } from 'react';

import { NavigationContext } from '..';

export const useNavigationContext = () => useContext(NavigationContext);
